module.exports = __webpack_public_path__ + "img/3.cfcc0a4e.jpg";